<p-dialog
    header="Edit Game"
    [visible]="visibleSignal()"
    (visibleChange)="onVisibleChange($event)"
    [style]="{ width: '53rem' }"
    [breakpoints]="{ '1280px': '95vw' }"
    [modal]="true"
    [closable]="!saving()"
    [draggable]="false"
>
    @if (editingGame(); as g) {
    <p-tabs [value]="activeTab()" (valueChange)="activeTab.set($any($event))">
        <p-tablist>
            <p-tab value="general">General</p-tab>
            <p-tab value="art">Art</p-tab>
        </p-tablist>
        <p-tabpanels>
            <p-tabpanel value="general">
                <div
                    class="flex flex-col gap-3"
                    (keydown.control.enter)="save()"
                    (keydown.meta.enter)="save()"
                >
                    <div class="text-xs text-muted-color">
                        Toggle <span class="font-medium">Override</span> to set a
                        realm-specific value. Otherwise the template value is
                        used.
                    </div>

                    <!-- IsActive -->
                    <div
                        class="flex flex-col gap-2 pt-2 border-t border-surface-200 dark:border-surface-700"
                    >
                        <div class="flex items-center justify-between">
                            <label class="font-medium">Active</label>
                            <div class="flex items-center gap-2">
                                <p-checkbox
                                    inputId="ovr-active"
                                    [binary]="true"
                                    [ngModel]="draft().IsActive.override"
                                    (ngModelChange)="
                                        toggleOverride('IsActive', $event)
                                    "
                                />
                                <label for="ovr-active" class="text-sm"
                                    >Override</label
                                >
                            </div>
                        </div>
                        <div class="flex items-center gap-3">
                            <p-checkbox
                                inputId="val-active"
                                [binary]="true"
                                [ngModel]="draft().IsActive.value"
                                (ngModelChange)="
                                    setOverrideValue('IsActive', $event)
                                "
                                [disabled]="!draft().IsActive.override"
                            />
                            <label for="val-active" class="text-sm">{{
                                draft().IsActive.value ? 'Active' : 'Inactive'
                            }}</label>
                            @if (!draft().IsActive.override) {
                            <span class="text-xs text-muted-color"
                                >(template: {{ templatePreview('IsActive')
                                }})</span
                            >
                            }
                        </div>
                    </div>

                    <!-- Title -->
                    <div
                        class="flex flex-col gap-2 pt-2 border-t border-surface-200 dark:border-surface-700"
                    >
                        <div class="flex items-center justify-between">
                            <label class="font-medium">Title</label>
                            <div class="flex items-center gap-2">
                                <p-checkbox
                                    inputId="ovr-title"
                                    [binary]="true"
                                    [ngModel]="draft().Title.override"
                                    (ngModelChange)="
                                        toggleOverride('Title', $event)
                                    "
                                />
                                <label for="ovr-title" class="text-sm"
                                    >Override</label
                                >
                            </div>
                        </div>
                        <input
                            pInputText
                            [ngModel]="draft().Title.value"
                            (ngModelChange)="
                                setOverrideValue('Title', $event ?? '')
                            "
                            [disabled]="!draft().Title.override"
                            [placeholder]="templatePreview('Title')"
                        />
                    </div>

                    <!-- Description -->
                    <div
                        class="flex flex-col gap-2 pt-2 border-t border-surface-200 dark:border-surface-700"
                    >
                        <div class="flex items-center justify-between">
                            <label class="font-medium">Description</label>
                            <div class="flex items-center gap-2">
                                <p-checkbox
                                    inputId="ovr-desc"
                                    [binary]="true"
                                    [ngModel]="draft().Description.override"
                                    (ngModelChange)="
                                        toggleOverride('Description', $event)
                                    "
                                />
                                <label for="ovr-desc" class="text-sm"
                                    >Override</label
                                >
                            </div>
                        </div>
                        <textarea
                            pTextarea
                            rows="5"
                            [ngModel]="draft().Description.value"
                            (ngModelChange)="
                                setOverrideValue('Description', $event ?? '')
                            "
                            [disabled]="!draft().Description.override"
                            [placeholder]="templatePreview('Description')"
                        ></textarea>
                    </div>

                    <!-- IsFeatured -->
                    <div
                        class="flex flex-col gap-2 pt-2 border-t border-surface-200 dark:border-surface-700"
                    >
                        <div class="flex items-center justify-between">
                            <label class="font-medium">Featured</label>
                            <div class="flex items-center gap-2">
                                <p-checkbox
                                    inputId="ovr-featured"
                                    [binary]="true"
                                    [ngModel]="draft().IsFeatured.override"
                                    (ngModelChange)="
                                        toggleOverride('IsFeatured', $event)
                                    "
                                />
                                <label for="ovr-featured" class="text-sm"
                                    >Override</label
                                >
                            </div>
                        </div>
                        <div class="flex items-center gap-3">
                            <p-checkbox
                                inputId="val-featured"
                                [binary]="true"
                                [ngModel]="draft().IsFeatured.value"
                                (ngModelChange)="
                                    setOverrideValue('IsFeatured', $event)
                                "
                                [disabled]="!draft().IsFeatured.override"
                            />
                            <label for="val-featured" class="text-sm">{{
                                draft().IsFeatured.value ? 'Yes' : 'No'
                            }}</label>
                            @if (!draft().IsFeatured.override) {
                            <span class="text-xs text-muted-color"
                                >(template: {{ templatePreview('IsFeatured')
                                }})</span
                            >
                            }
                        </div>
                    </div>

                    @if (saveError()) {
                    <p-message severity="error" [text]="saveError()!" />
                    }
                </div>
            </p-tabpanel>

            <p-tabpanel value="art">
                <app-realm-game-art-panel
                    [adminGame]="editingGame()"
                    [siteTemplateId]="siteTemplateIdSignal()"
                    [active]="artActive()"
                    (gameUpdated)="onGameUpdated($event)"
                />
            </p-tabpanel>
        </p-tabpanels>
    </p-tabs>
    }

    <ng-template #footer>
        <div class="flex items-center justify-between gap-2 w-full">
            <span class="text-xs text-muted-color">
                @if (activeTab() === 'art') { Art changes apply immediately. }
            </span>
            <div class="flex justify-end gap-2">
                <p-button
                    label="Close"
                    severity="secondary"
                    outlined
                    [disabled]="saving()"
                    (onClick)="close()"
                />
                <p-button
                    label="Save"
                    icon="pi pi-check"
                    [loading]="saving()"
                    [disabled]="!canSave()"
                    (onClick)="save()"
                />
            </div>
        </div>
    </ng-template>
</p-dialog>
